import { camelCase, isArray, isObject, snakeCase, transform } from 'lodash'

export const toCamelCase = (obj, ignoreKeys = []) =>
  transform(obj, (acc, value, key, target) => {
    const camelKey = isArray(target) ? key : (ignoreKeys.includes(key) ? key : camelCase(key))

    acc[camelKey] = isObject(value) ? toCamelCase(value, ignoreKeys) : value
  })

export const toSnakeCase = (obj, ignoreKeys = []) =>
  transform(obj, (acc, value, key, target) => {
    const snakeKey = isArray(target) ? key : (ignoreKeys.includes(key) ? key : snakeCase(key))

    acc[snakeKey] = isObject(value) ? toSnakeCase(value, ignoreKeys) : value
  })


export const isFile = (obj) => obj instanceof File

export const isUrl = string => {
  try {
    return Boolean(new URL(string))
  } catch (e) {
    return false
  }
}
